import { Label } from './style';
import UploadI from '../../assets/icons/upload.svg?react';

const UploadFile = () => {
  return (
    <Label htmlFor="uploadFiles">
      <UploadI />
      <h4>Drag & Drop or Choose file to upload</h4>
      <p>PDF, XLS or CSV. Max size of 12MB</p>
      <input type="file" id="uploadFiles" />
    </Label>
  );
};

export default UploadFile;
